import { render, staticRenderFns } from "./rcpts.vue?vue&type=template&id=6ef746ba&"
import script from "./rcpts.vue?vue&type=script&lang=ts&"
export * from "./rcpts.vue?vue&type=script&lang=ts&"
import style0 from "./rcpts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports